import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { SearchRecord, SearchPackage } from '../../models/searchPackage';
import * as _ from 'lodash';
import { SearchPackageService } from 'src/app/services/search-package.service';
import { NgForm } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchManagementDialogComponent } from '../search-management-dialog/search-management-dialog.component';
import { ObjectUpdatePayload } from 'src/app/models/screeningInvite';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-editable-search-list',
  templateUrl: './editable-search-list.component.html',
  styleUrls: ['./editable-search-list.component.less']
})
export class EditableSearchListComponent implements OnInit {

  @Input() public package: SearchPackage;
  @Output() public searchSaved : EventEmitter<SearchRecord> = new EventEmitter<SearchRecord>();

  constructor(public auth: AuthService,
    public searches: SearchPackageService,
    public toast: ToastrService) { }


  ngOnInit() {
    console.log('edit search list component loaded', this.package);
  }

  GetCreditRepositoryName(repo: number) {
    try {
      return this.searches.creditRepositories.find(r => { return r.id == repo }).name;
    } catch (error) {

    }
  }

  updateSearchCost(evt: any){
    // console.warn('Calling Search Update on editable search list', evt);
    this.searchSaved.emit(evt);
  }
}
